import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import WebFontLoader from 'webfontloader';
import 'ric';
import { Subject } from 'rxjs';
import { buffer, debounceTime, map } from 'rxjs/operators';
import { newId } from '@slidebean/sdk';

class FontLoader {
    constructor() {
        this.loadedFonts = new Map();
        this.googleFonts$ = new Subject();
        this.otherWebFonts$ = new Subject();
        this.googleFonts$
            .pipe(buffer(this.googleFonts$.pipe(debounceTime(100))), map(fonts => fonts.reduce((groupedFont, font) => {
            groupedFont.google.families.push(...font.google.families);
            return groupedFont;
        }, {
            google: {
                families: [],
            },
        })))
            .subscribe(WebFontLoader.load);
        this.otherWebFonts$
            .pipe(buffer(this.otherWebFonts$.pipe(debounceTime(100))))
            .subscribe(fonts => fonts.forEach(WebFontLoader.load));
    }
    load(font, { force } = { force: false }) {
        const { fontId } = font;
        if (force || !this.loadedFonts.has(fontId)) {
            this.loadedFonts.set(fontId, true);
            if ('webfont' in font) {
                const { webfont } = font;
                if (!!webfont.google) {
                    this.googleFonts$.next(webfont);
                }
                else {
                    this.otherWebFonts$.next(webfont);
                }
            }
            else if ('fontFileUrl' in font) {
                const { fontFileUrl } = font;
                window.requestIdleCallback(() => this.appendFont({ fontId, fontUrl: fontFileUrl }));
            }
        }
    }
    loadByUrl(fontUrl) {
        return new Promise(resolve => {
            window.requestIdleCallback(() => {
                const fontId = `f_${newId()}`;
                this.appendFont({ fontId, fontUrl });
                resolve(fontId);
            });
        });
    }
    appendFont({ fontId, fontUrl, }) {
        this.appendCSS(`
      @font-face {
        font-family: '${fontId}';
        src: url('${fontUrl}');
      }
    `);
    }
    appendCSS(css) {
        const head = document.head || document.getElementsByTagName('head')[0];
        const style = document.createElement('style');
        style.type = 'text/css';
        style.appendChild(document.createTextNode(css));
        head.appendChild(style);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: FontLoader, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: FontLoader, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: FontLoader, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

/**
 * Generated bundle index. Do not edit.
 */

export { FontLoader };
